import RequestNetworkProblemError from './errors/RequestNetworkProblemError';
import RequestTimeoutError from './errors/RequestTimeoutError';
export default class RequestSender {
    static async sendRequest(url, requestInit, timeout) {
        let response;
        try {
            response = await Promise.race([
                fetch(url, requestInit),
                new Promise((res, rej) => {
                    setTimeout(() => {
                        rej(new RequestTimeoutError(url, requestInit, timeout));
                    }, timeout);
                }),
            ]);
        }
        catch (err) {
            if (err instanceof RequestTimeoutError) {
                throw err;
            }
            throw new RequestNetworkProblemError(url, requestInit, err);
        }
        return response;
    }
}
